// @need-translate
import {getEnv} from '../../common/env/env';
import {RouletteEntryTypeVo} from '../../common/shared/api/nicolas/vo/enums/RouletteEntryTypeVo.enum';
import {RouletteStatusVo} from '../../common/shared/api/nicolas/vo/enums/RouletteStatusVo.enum';
import {RouletteTypeVo} from '../../common/shared/api/nicolas/vo/enums/RouletteTypeVo.enum';
import {RouletteMainResponseVo} from '../../common/shared/api/nicolas/vo/RouletteMainResponseVo.interface';
import {DEFAULT_ROULETTE_BG_COLOR} from '../../domain/gacha/constant';
import {RouletteInfo} from '../generated/types';
import {createRouletteEntryType} from './RouletteEntryType';
import {createRoulettePrize} from './RoulettePrize';
import {createRoulettePrizeType} from './RoulettePrizeType';
import {createRouletteStatus} from './RouletteStatus';
import {createRouletteType} from './RouletteType';

export function createRouletteInfo(
  data: RouletteMainResponseVo,
  rouletteId: string
): RouletteInfo {
  const isCashDirectType =
    data.type === RouletteTypeVo.Standalone &&
    data.entry_type === RouletteEntryTypeVo.None;
  const isRedeemType = data.entry_type === RouletteEntryTypeVo.RedeemV2;
  const isDirectType = data.entry_type === RouletteEntryTypeVo.DirectV2;
  return {
    rouletteId,
    rouletteAdLocId: data.ad_loc_id,
    rouletteStatus: createRouletteStatus(
      !data.type ? RouletteStatusVo.Error : data.status
    ),

    headerTitle: isCashDirectType ? '캐시 뽑기권' : (data.title ?? ''),
    screenTitle: isCashDirectType
      ? '꽝없는\n캐시뽑기'
      : (data.screen_title ?? ''),
    maxCash: data.max_cash,
    resultBottomTextList: data.below_desc?.split('\n').filter(Boolean) ?? [],

    bgImg: getImageUrl(data.background_img),
    bgColor: isCashDirectType
      ? DEFAULT_ROULETTE_BG_COLOR
      : data.background_color,

    isSponsorType:
      data.type === RouletteTypeVo.CashSponsor &&
      (isRedeemType || isDirectType),
    isRedeemType,
    isOldRoulette: !isCashDirectType && !isRedeemType && !isDirectType,

    type: createRouletteType(data.type),
    entryType: createRouletteEntryType(data.entry_type),

    prize: createRoulettePrize(data.win_prize, data.win_prize_type),
    prizeType: createRoulettePrizeType(data.win_prize_type),
    prizeImageUrl: getImageUrl(data.spin_wheel_ready_imgs),
    badgeImageUrl: getImageUrl(data.top_title_img),

    winningDate: data.receive_date,
    expirationDate: data.expire_date_text,

    bannerAdLocId: data.banner_ad_loc_id,
    bannerImageUrl: getImageUrl(data.ext_banner_img),
    bannerLink: data.ext_banner_link,
  };
}

function getImageUrl(url?: string) {
  const kageUrlPrefix = getEnv().kageUrlPrefix;
  return url ? `${kageUrlPrefix}${url}` : undefined;
}
